export default __webpack_public_path__ + "static/media/LoginPage.6901cd4c.png";